import React from 'react'
import Hero from './Hero'

import WhyChoosePFA from './WhyChoosePFA';
import HomeServices from './HomeServices';

const Home = () => {
  return (
    <div>
      <Hero/>
      <HomeServices/>
      
      <WhyChoosePFA/>
    </div>
    
   
   
  );
}

export default Home
